import React from 'react';
import { Grid } from '@material-ui/core';
import { Add, CloudUpload } from '@material-ui/icons';
import LargeIconButton from 'components/theme/LargeIconButton';
import language from 'utils/vast-languagepack';

export default ({
  history,
  title,
  shortLabel,
  endpoint,
  bulkUpload,
  addOrEditPath,
  addOrEditComponent,
  helperText,
  guideUrl,
  path,
  customAddPath,
}) => (
  <Grid
    style={{
      margin: '0 auto',
      width: '100%',
      backgroundColor: '#fff',
      border: 'solid 1px #adadad',
      borderRadius: 15,
      fontSize: 20,
      textAlign: 'center',
      padding: 40,
    }}
    container
    spacing={24}
    justify='center'
  >
    {bulkUpload ? (
      <Grid item xs={12}>
        <p>
          {helperText}
          <a href={guideUrl} target='_blank' rel='noopener noreferrer'>
            Learn More
          </a>
        </p>
        You have no {`${title || `${endpoint}s`}`}, manually add a{' '}
        {`${shortLabel || endpoint}`} or upload a csv by clicking one of the
        buttons below.
      </Grid>
    ) : (
      <Grid item xs={12}>
        <p>
          {helperText}
          <a href={guideUrl} target='_blank' rel='noopener noreferrer'>
            Learn More
          </a>
        </p>
        No {`${title || `${endpoint}s`}`} to display. Please click the button
        below to create a new {`${shortLabel || endpoint}`}
      </Grid>
    )}
    <Grid
      item
      xs={12}
      justify='center'
      spacing={24}
      container
      style={{ maxWidth: 672, marginTop: 16 }}
    >
      <Grid item xs={6}>
        {
          addOrEditComponent ? addOrEditComponent :
            <LargeIconButton
              style={{ maxWidth: 300 }}
              onClick={() => history.push(customAddPath || addOrEditPath('new'))}
              Icon={Add}
            >
              {`Add ${shortLabel || endpoint}`}
            </LargeIconButton>
        }
       
      </Grid>
      {bulkUpload ? (
        <Grid item xs={6}>
          <LargeIconButton
            style={{ maxWidth: 300 }}
            onClick={() => history.push(`${path}/upload`)}
            Icon={CloudUpload}
          >
            {language.contacts.add.bulkUpload}
          </LargeIconButton>
        </Grid>
      ) : null}
    </Grid>
  </Grid>
);
